// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Peru from '../_raw/flag/icon_flag_peru.png';

export default () => <img src={Peru} alt="Peru" />;
